"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _bootstrapUtils = require("react-bootstrap/lib/utils/bootstrapUtils");
var _Button = _interopRequireDefault(require("./Button"));
require("./Input.scss");
var _excluded = ["ariaLabel", "label", "help", "addonBefore", "addonAfter", "buttonBefore", "buttonAfter", "hasBorder", "groupClassName", "innerRef", "labelClassName", "wrapperClassName", "initialValue", "autofill", "onUpdate", "valid", "invalid", "dirty", "pristine", "active", "touched", "visited", "autofilled"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /**
 * A React 16 compliant version of https://github.com/angieslist/AL_Custom_React_Bootstrap/blob/master/src/Input.jsx.
 * Passing an "id" is required whereas the legacy control would create a UUID.
 * Besides the "id" other properties have been maintained to maintain backwards compatibility.
 */
var Input = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Input, _React$Component);
  var _super = _createSuper(Input);
  function Input(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Input);
    _this = _super.call(this, props);
    _this.state = {
      focused: false
    };
    return _this;
  }
  (0, _createClass2["default"])(Input, [{
    key: "isCheckboxOrRadio",
    value: function isCheckboxOrRadio() {
      var type = this.props.type;
      return type === 'radio' || type === 'checkbox';
    }
  }, {
    key: "isFile",
    value: function isFile() {
      var type = this.props.type;
      return type === 'file';
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this2 = this;
      var input = null;
      var _this$props = this.props,
        ariaLabelKebab = _this$props['aria-label'],
        ariaLabel = _this$props.ariaLabel,
        bsStyle = _this$props.bsStyle,
        children = _this$props.children,
        error = _this$props.error,
        id = _this$props.id,
        label = _this$props.label,
        placeholder = _this$props.placeholder,
        text = _this$props.text,
        type = _this$props.type,
        value = _this$props.value,
        onFocus = _this$props.onFocus,
        onBlur = _this$props.onBlur;
      var defaultOnFocus = function defaultOnFocus(e) {
        if (onFocus) {
          onFocus(e);
        }
        _this2.setState(function () {
          return {
            focused: true
          };
        });
      };
      var defaultOnBlur = function defaultOnBlur(e) {
        if (onBlur) {
          onBlur(e);
        }
        _this2.setState(function () {
          return {
            focused: false
          };
        });
      };
      if (!type) {
        return children;
      }
      var ariaTags = {
        'aria-label': ariaLabelKebab || ariaLabel || label || placeholder || text,
        'aria-invalid': bsStyle === 'error' || typeof error !== 'undefined' && error !== '' || undefined,
        'aria-describedby': "".concat(id, "-help")
      };
      var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(this.props),
        _splitBsProps2 = (0, _slicedToArray2["default"])(_splitBsProps, 2),
        elementProps = _splitBsProps2[1];
      var skipAriaLabel = elementProps.ariaLabel,
        skipLabel = elementProps.label,
        help = elementProps.help,
        addonBefore = elementProps.addonBefore,
        addonAfter = elementProps.addonAfter,
        buttonBefore = elementProps.buttonBefore,
        buttonAfter = elementProps.buttonAfter,
        hasBorder = elementProps.hasBorder,
        groupClassName = elementProps.groupClassName,
        innerRef = elementProps.innerRef,
        labelClassName = elementProps.labelClassName,
        wrapperClassName = elementProps.wrapperClassName,
        initialValue = elementProps.initialValue,
        autofill = elementProps.autofill,
        onUpdate = elementProps.onUpdate,
        valid = elementProps.valid,
        invalid = elementProps.invalid,
        dirty = elementProps.dirty,
        pristine = elementProps.pristine,
        active = elementProps.active,
        touched = elementProps.touched,
        visited = elementProps.visited,
        autofilled = elementProps.autofilled,
        props = (0, _objectWithoutProperties2["default"])(elementProps, _excluded);
      switch (props.type) {
        case 'select':
          input = /*#__PURE__*/_react["default"].createElement("select", (0, _extends2["default"])({}, props, {
            className: (0, _classnames["default"])(props.className, 'form-control', 'arc-Input'),
            ref: innerRef,
            key: "input"
          }, ariaTags), children);
          break;
        case 'textarea':
          input = /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({}, props, {
            className: (0, _classnames["default"])(props.className, 'form-control', 'arc-Input-textarea'),
            ref: innerRef,
            key: "input"
          }, ariaTags));
          break;
        case 'static':
          input = /*#__PURE__*/_react["default"].createElement("p", (0, _extends2["default"])({}, props, {
            className: (0, _classnames["default"])(props.className, 'form-control-static'),
            ref: innerRef,
            key: "input"
          }, ariaTags), value);
          break;
        case 'submit':
          input = /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
            componentClass: "input",
            ref: innerRef,
            key: "input"
          }, ariaTags));
          break;
        case 'file':
          input = /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
            className: (0, _classnames["default"])(props.className),
            ref: innerRef,
            key: "input"
          }, ariaTags));
          break;
        case 'checkbox':
          input = /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
            className: (0, _classnames["default"])(props.className),
            ref: innerRef,
            key: "input"
          }, ariaTags));
          break;
        case 'radio':
          input = /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
            className: (0, _classnames["default"])(props.className),
            ref: innerRef,
            key: "input"
          }, ariaTags));
          break;
        default:
          {
            var className = 'form-control arc-Input';
            var addOnClassNames = function () {
              if (addonAfter && addonBefore) {
                return 'with-addon-before-and-after';
              }
              if (addonAfter) {
                return 'with-addon-after';
              }
              if (addonBefore) {
                return 'with-addon-before';
              }
              return 'no-addon';
            }();
            input = /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, props, {
              className: (0, _classnames["default"])(props.className, className, addOnClassNames),
              ref: innerRef,
              key: "input"
            }, ariaTags, {
              onFocus: defaultOnFocus,
              onBlur: defaultOnBlur
            }));
          }
      }
      return input;
    }
  }, {
    key: "renderInputGroup",
    value: function renderInputGroup(children) {
      var _this$props2 = this.props,
        addonAfter = _this$props2.addonAfter,
        addonBefore = _this$props2.addonBefore,
        buttonBefore = _this$props2.buttonBefore,
        buttonAfter = _this$props2.buttonAfter;
      var focused = this.state.focused;
      var beforeAddOnClassName = focused ? 'input-group-addon input-group-addon-before focused' : 'input-group-addon input-group-addon-before';
      var afterAddOnClassName = focused ? 'input-group-addon input-group-addon-after focused' : 'input-group-addon input-group-addon-after';
      var addonBeforeSpan = addonBefore ? /*#__PURE__*/_react["default"].createElement("span", {
        className: beforeAddOnClassName,
        key: "addonBefore"
      }, addonBefore) : null;
      var addonAfterSpan = addonAfter ? /*#__PURE__*/_react["default"].createElement("span", {
        className: afterAddOnClassName,
        key: "addonAfter"
      }, addonAfter) : null;
      var buttonBeforeSpan = buttonBefore ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-btn"
      }, buttonBefore) : null;
      var buttonAfterSpan = buttonAfter ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-group-btn"
      }, buttonAfter) : null;
      var inputGroupClassNames = addonAfter ? 'input-group input-group-with-addon-after' : 'input-group';
      return addonBefore || addonAfter || buttonBefore || buttonAfter ? /*#__PURE__*/_react["default"].createElement("div", {
        className: inputGroupClassNames,
        key: "input-group"
      }, addonBeforeSpan, buttonBeforeSpan, children, addonAfterSpan, buttonAfterSpan) : children;
    }
  }, {
    key: "renderHelp",
    value: function renderHelp() {
      var _this$props3 = this.props,
        error = _this$props3.error,
        help = _this$props3.help,
        id = _this$props3.id,
        touched = _this$props3.touched;
      var helpId = "".concat(id, "-help");
      return help || error && touched ? /*#__PURE__*/_react["default"].createElement("span", {
        className: "help-block",
        key: "help",
        id: helpId
      }, error || help) : null;
    }
  }, {
    key: "renderCheckboxandRadioWrapper",
    value: function renderCheckboxandRadioWrapper(children) {
      var _this$props4 = this.props,
        type = _this$props4.type,
        hasBorder = _this$props4.hasBorder;
      var classes = {
        checkbox: type === 'checkbox',
        radio: type === 'radio'
      };
      var additionalClassNames = function () {
        if (hasBorder) {
          return 'with-border';
        }
        return 'no-border';
      }();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes, additionalClassNames),
        key: "checkboxRadioWrapper"
      }, children);
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(children) {
      var wrapperClassName = this.props.wrapperClassName;
      return wrapperClassName ? /*#__PURE__*/_react["default"].createElement("div", {
        className: wrapperClassName,
        key: "wrapper"
      }, children) : children;
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(children) {
      var classes = {
        'control-label': !this.isCheckboxOrRadio()
      };
      var _this$props5 = this.props,
        id = _this$props5.id,
        label = _this$props5.label,
        labelClassName = _this$props5.labelClassName;
      classes[labelClassName] = labelClassName;
      return label ?
      /*#__PURE__*/
      // label renders an input as children so disable eslint check
      // eslint-disable-next-line jsx-a11y/label-has-for
      _react["default"].createElement("label", {
        htmlFor: id,
        className: (0, _classnames["default"])(classes),
        key: "label"
      }, children, /*#__PURE__*/_react["default"].createElement("span", {
        className: "input-label-text"
      }, label)) : children;
    }
  }, {
    key: "renderFormGroup",
    value: function renderFormGroup(children) {
      var _this$props6 = this.props,
        bsStyle = _this$props6.bsStyle,
        error = _this$props6.error,
        groupClassName = _this$props6.groupClassName,
        touched = _this$props6.touched;
      var classes = {
        'form-group': true,
        'has-success': bsStyle === 'success',
        'has-warning': bsStyle === 'warning',
        'has-error': bsStyle === 'error' || error && touched
      };
      classes[groupClassName] = groupClassName;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes)
      }, children);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isCheckboxOrRadio()) {
        return this.renderFormGroup(this.renderWrapper([this.renderCheckboxandRadioWrapper(this.renderLabel(this.renderInput())), this.renderHelp()]));
      }
      return this.renderFormGroup([this.renderLabel(), this.renderWrapper([this.renderInputGroup(this.renderInput()), this.renderHelp()])]);
    }
  }]);
  return Input;
}(_react["default"].Component);
Input.propTypes = {
  type: _propTypes["default"].string,
  label: _propTypes["default"].node,
  help: _propTypes["default"].node,
  error: _propTypes["default"].string,
  addonBefore: _propTypes["default"].node,
  addonAfter: _propTypes["default"].node,
  buttonBefore: _propTypes["default"].node,
  buttonAfter: _propTypes["default"].node,
  bsStyle: function bsStyle(props) {
    var _context;
    if (props.type !== 'submit') {
      // Return early if `type=submit` as the `Button` component
      // it transfers these props to has its own propType checks.
      return undefined;
    }
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    return _propTypes["default"].oneOf(['success', 'warning', 'error']).apply(void 0, (0, _concat["default"])(_context = [props]).call(_context, rest));
  },
  groupClassName: _propTypes["default"].string,
  wrapperClassName: _propTypes["default"].string,
  labelClassName: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string, _propTypes["default"].number]),
  touched: _propTypes["default"].bool,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  'aria-label': _propTypes["default"].string,
  ariaLabel: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  text: _propTypes["default"].string,
  children: _propTypes["default"].node,
  hasBorder: _propTypes["default"].bool
};
Input.defaultProps = {
  type: undefined,
  label: undefined,
  help: undefined,
  error: undefined,
  addonBefore: undefined,
  addonAfter: undefined,
  buttonBefore: undefined,
  buttonAfter: undefined,
  bsStyle: undefined,
  groupClassName: undefined,
  wrapperClassName: undefined,
  labelClassName: undefined,
  disabled: undefined,
  // id
  value: undefined,
  touched: undefined,
  onFocus: undefined,
  onBlur: undefined,
  'aria-label': undefined,
  ariaLabel: undefined,
  placeholder: undefined,
  text: undefined,
  children: undefined,
  hasBorder: false
};

// Use React.forwardRef to enable idiomatic <Input ref={myRef} />
// eslint-disable-next-line react/no-multi-comp
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(Input, (0, _extends2["default"])({
    innerRef: ref
  }, props));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Input.js
// module id = 66
// module chunks = 25